import { MdShape } from '../../types'
import { getDefaultMargin, getDefaultMarginOverlay, getDefaultWidthOverlay } from '../utils'

export const PromptDesignSettings = {
  // dimension
  'prompt-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['100%'],
    tv: ['100%'],
    overflowSetting: getDefaultWidthOverlay,
  },
  // spacing
  'prompt-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
    overflowSetting: getDefaultMarginOverlay,
  },
  // alignment
  'prompt-design-h-align': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },
  'prompt-design-chips-alignment': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'prompt-design-divider-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'prompt-design-divider-color-solid': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'prompt-design-divider-color-start-gradient': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'prompt-design-divider-color-end-gradient': {
    light: 'primary-80',
    dark: 'primary-80',
  },
  'prompt-design-divider-color-gradient-direction': {
    light: 'to-right',
    dark: 'to-right',
  },
  'prompt-design-placeholder-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'prompt-design-placeholder-color-solid': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'prompt-design-placeholder-color-start-gradient': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'prompt-design-placeholder-color-end-gradient': {
    light: 'primary-80',
    dark: 'primary-80',
  },
  'prompt-design-placeholder-color-gradient-direction': {
    light: 'to-right',
    dark: 'to-right',
  },
  'prompt-design-background-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'prompt-design-background-color-solid': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'prompt-design-background-color-start-gradient': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'prompt-design-background-color-end-gradient': {
    light: 'primary-80',
    dark: 'primary-80',
  },
  'prompt-design-background-color-gradient-direction': {
    light: 'to-right',
    dark: 'to-right',
  },
  'prompt-design-button-color-variant': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'prompt-design-button-color-variant-solid': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'prompt-design-button-color-variant-start-gradient': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'prompt-design-button-color-variant-end-gradient': {
    light: 'primary-80',
    dark: 'primary-80',
  },
  'prompt-design-button-color-variant-gradient-direction': {
    light: 'to-right',
    dark: 'to-right',
  },
  'prompt-design-chip-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'prompt-design-chip-color-solid': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'prompt-design-chip-color-start-gradient': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'prompt-design-chip-color-end-gradient': {
    light: 'primary-80',
    dark: 'primary-80',
  },
  'prompt-design-chip-color-gradient-direction': {
    light: 'to-right',
    dark: 'to-right',
  },
  'prompt-design-corner-radius': {
    phone: MdShape.Medium,
    'phone-landscape': MdShape.Medium,
    tablet: MdShape.Medium,
    'tablet-landscape': MdShape.Medium,
    desktop: MdShape.Medium,
    tv: MdShape.Medium,
  },
  'prompt-design-number-default-items': {
    phone: 4,
    'phone-landscape': 4,
    tablet: 4,
    'tablet-landscape': 4,
    desktop: 4,
    tv: 4,
  },
}
